<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">schedule</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Kontrolltermine</h2>
      </div>
    </div>






    
  <!-- Search and Filter Section -->
  <div class="mt-6 mb-6">
    <div class="flex flex-row gap-4 items-center">
      <!-- Search Box - Hidden for now -->
      <!--
      <div class="flex-none">
        <div class="w-48">
          <div class="relative">
            <input
              class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md pl-3 pr-20 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
              placeholder="Kontrolltermine suchen..." 
              [(ngModel)]="searchTerm"
              (keyup)="onSearch()"
            />
            <button
              class="absolute top-1 right-1 flex items-center rounded bg-slate-800 py-1 px-2 border border-transparent text-center text-xs text-white transition-all shadow-sm hover:shadow focus:bg-slate-700 focus:shadow-none active:bg-slate-700 hover:bg-slate-700 active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
              type="button"
              *ngIf="searchTerm"
              (click)="clearSearch()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3 mr-1">
                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
              Clear
            </button>
          </div>
        </div>
      </div>
      -->

            <!-- Kunde Autocomplete Filter -->
      <div class="flex-none">
        <div class="relative">
          <input
            type="text"
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[140px]"
            placeholder="Kunde suchen..."
            [(ngModel)]="kundeSearchValue"
            (input)="onKundeSearch($event)"
            (focus)="showKundeAutocomplete = true"
            (blur)="onKundeBlur()"
            [value]="getKundeDisplayValue()"
          />
          
          <!-- Clear button for Kunde -->
          <button
            *ngIf="selectedKunde"
            type="button"
            class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            (click)="clearKundeFilter()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
              <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
          </button>

          <!-- Kunde Autocomplete Dropdown -->
          <div
            *ngIf="showKundeAutocomplete && filteredKunden.length > 0"
            class="absolute left-0 z-50 mt-2 w-80 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto">
            <div class="py-1" role="none">
              <button
                *ngFor="let kunde of filteredKunden"
                type="button"
                class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                role="menuitem"
                tabindex="-1"
                (click)="selectKunde(kunde)">
                <div class="font-medium">{{ kunde.suchbegriff || kunde.name }}</div>
                <div class="text-xs text-gray-500" *ngIf="kunde.name && kunde.suchbegriff !== kunde.name">{{ kunde.name }}</div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Techniker Select Filter -->
      <div class="flex-none">
        <div class="relative">
          <select
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[160px] appearance-none bg-no-repeat bg-right bg-[length:16px_12px] pr-8"
            style="background-image: url('data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e');"
            [value]="selectedVerantwortlicher?.id?.toString() || ''"
            (change)="onTechnikerChange($event.target.value)"
          >
            <option value="">Alle Techniker</option>
            <option *ngFor="let techniker of techniker" [value]="techniker.id.toString()">
              {{ techniker.nachname }}, {{ techniker.vorname }}
            </option>
          </select>
        </div>
      </div>

      <!-- Month Filter -->
      <div class="flex-none">
        <div class="relative">
          <select
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-gray-50 min-w-[140px] appearance-none bg-no-repeat bg-right bg-[length:16px_12px] pr-8"
            style="background-image: url('data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e');"
            [(ngModel)]="selectedMonth"
            (change)="onMonthChange($event.target.value)"
          >
            <option value="">Alle Monate</option>
            <option *ngFor="let month of months" [value]="month.value">
              {{ month.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- Standort Autocomplete Filter -->
      <div class="flex-none">
        <div class="relative">
          <input
            type="text"
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[160px]"
            placeholder="Standort suchen..."
            [(ngModel)]="standortSearchValue"
            (input)="onStandortSearch($event)"
            (focus)="showStandortAutocomplete = true"
            (blur)="onStandortBlur()"
            [value]="getStandortDisplayValue()"
          />
          
          <!-- Clear button for Standort -->
          <button
            *ngIf="selectedStandort"
            type="button"
            class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            (click)="clearStandortFilter()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
              <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1 0-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
          </button>

          <!-- Standort Autocomplete Dropdown -->
          <div
            *ngIf="showStandortAutocomplete && filteredStandorte.length > 0"
            class="absolute left-0 z-50 mt-2 w-80 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto">
            <div class="py-1" role="none">
              <button
                *ngFor="let standort of filteredStandorte"
                type="button"
                class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                role="menuitem"
                tabindex="-1"
                (click)="selectStandort(standort)">
                <div class="font-medium">{{ standort.name }}</div>
                <div class="text-xs text-gray-500" *ngIf="standort.nummer">Nr. {{ standort.nummer }}</div>
              </button>
            </div>
          </div>
        </div>
      </div>



      <!-- Clear All Filters Button -->
      <div class="flex items-end">
        <button 
          mat-stroked-button 
          (click)="clearFilters()"
          class="h-10">
          <mat-icon class="mr-2 w-5 h-5">clear_all</mat-icon>
          Filter löschen
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-12">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    <span class="ml-4 text-gray-600">Lade Kontrolltermine...</span>
  </div>

  <!-- mat tab group -->
   <!-- BUTTON BAR AS TAB NAV -->
<div
class="btnbar"
role="tablist"
aria-label="Status navigation"
>
<button
  type="button"
  class="mt-2 btn btn-lg btn-geloescht btn-arrow-right relative"
  role="tab"
  [attr.aria-selected]="isSelected('others')"
  (click)="openOthersDropdown()"
>
  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" style="min-height: 28px;">
    <circle cx="12" cy="12" r="8" fill="currentColor"/>
  </svg>
  <!-- Active indicator line -->
  <div 
    *ngIf="showOthersDropdown || isOthersActive" 
    class="absolute -bottom-2 left-0 right-0 h-1 rounded-full"
    style="background-color: #003671;"
  ></div>
</button>

<button
  type="button"
  class="mt-2 ml-2 btn btn-lg btn-geplant btn-arrow-right relative"
  role="tab"
  [attr.aria-selected]="isSelected('geplant')"
  (click)="select('geplant')"
>
  Geplant
  <!-- Active indicator line -->
  <div 
    *ngIf="isSelected('geplant')" 
    class="absolute -bottom-2 left-0 right-0 h-1 rounded-full"
    style="background-color: #003671;"
  ></div>
</button>

<button
  type="button"
  class="mt-2 ml-2 btn btn-lg btn-aktuell btn-arrow-right relative"
  role="tab"
  [attr.aria-selected]="isSelected('aktuell')"
  (click)="select('aktuell')"
>
  Aktuelle
  <!-- Active indicator line -->
  <div 
    *ngIf="isSelected('aktuell')" 
    class="absolute -bottom-2 left-0 right-0 h-1 rounded-full"
    style="background-color: #003671;"
  ></div>
</button>

<button
  type="button"
  class="mt-2 ml-2 btn btn-lg btn-bearbeitung btn-arrow-right relative"
  role="tab"
  [attr.aria-selected]="isSelected('bearbeitung')"
  (click)="select('bearbeitung')"
>
  in Bearbeitung
  <!-- Active indicator line -->
  <div 
    *ngIf="isSelected('bearbeitung')" 
    class="absolute -bottom-2 left-0 right-0 h-1 rounded-full"
    style="background-color: #003671;"
  ></div>
</button>

<button
  type="button"
  class="mt-2 ml-2 btn btn-lg btn-freigabe btn-arrow-right relative"
  role="tab"
  [attr.aria-selected]="isSelected('freigabe')"
  (click)="select('freigabe')"
>
  Freigabe
  <!-- Active indicator line -->
  <div 
    *ngIf="isSelected('freigabe')" 
    class="absolute -bottom-2 left-0 right-0 h-1 rounded-full"
    style="background-color: #003671;"
  ></div>
</button>

<button
  type="button"
  class="mt-2 ml-2 btn btn-lg btn-abgeschlossen btn-arrow-right relative"
  role="tab"
  [attr.aria-selected]="isSelected('abgeschlossen')"
  (click)="select('abgeschlossen')"
>
  Abgeschlossen
  <!-- Active indicator line -->
  <div 
    *ngIf="isSelected('abgeschlossen')" 
    class="absolute -bottom-2 left-0 right-0 h-1 rounded-full"
    style="background-color: #003671;"
  ></div>
</button>
</div>

<!-- Others Dropdown -->
<div 
  *ngIf="showOthersDropdown"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  (click)="hideOthersDropdown()"
>
  <div 
    class="bg-white rounded-lg shadow-xl p-6 min-w-[300px]"
    (click)="$event.stopPropagation()"
  >
    <h3 class="text-lg font-semibold text-gray-900 mb-4 text-center">Status auswählen</h3>
    <div class="space-y-3">
      <button
        *ngFor="let option of othersOptions"
        type="button"
        class="w-full text-left px-4 py-3 rounded-md border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors"
        (click)="selectOthersOption(option.value)"
      >
        <div class="font-medium text-gray-900">{{ option.label }}</div>
        <div class="text-sm text-gray-500">{{ option.description }}</div>
      </button>
    </div>
  </div>
</div>

<!-- Content based on selected tab -->
<div class="mt-6">
  <!-- Loading State -->
  <div *ngIf="kontrolltermineLoading" class="flex justify-center items-center py-12">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    <span class="ml-4 text-gray-600">Lade Kontrolltermine...</span>
  </div>

  <!-- Content -->
  <div *ngIf="!kontrolltermineLoading" class="mt-8 flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
          <thead>
            <tr>
              <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Datum</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Kunde</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Standort</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Techniker</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Ampel</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Status</th>
              <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                <span class="sr-only">Aktionen</span>
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
            <tr 
              *ngFor="let kontrolltermin of kontrolltermine; let i = index" 
              class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150 cursor-pointer"
              [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}"
              (click)="editKontrolltermin(kontrolltermin)">
              <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">{{ kontrolltermin.datum_durchfuerung | date:'dd.MM.yyyy' }}</td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontrolltermin.kunde?.suchbegriff || '-' }}</td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontrolltermin.standort?.name || '-' }}</td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ kontrolltermin.techniker?.vorname }} {{ kontrolltermin.techniker?.nachname || '-' }}</td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                <span class="inline-flex items-center rounded-full w-3 h-3"
                      [ngClass]="{
                        'bg-red-500': kontrolltermin.global_befall === 1,
                        'bg-green-500': kontrolltermin.global_befall === 0,
                        'bg-gray-400': kontrolltermin.global_befall === null || kontrolltermin.global_befall === undefined
                      }"
                      [title]="getBefallLabel(kontrolltermin.global_befall)">
                </span>
              </td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                      [ngClass]="getStatusClasses(kontrolltermin.status_id)">
                  {{ getStatusLabel(kontrolltermin.status_id) }}
                </span>
              </td>
              <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                <button 
                  (click)="editKontrolltermin(kontrolltermin, $event)"
                  mat-button
                  color="primary"
                  class="slim-button">
                  Bearbeiten
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!kontrolltermineLoading && kontrolltermine.length === 0" class="text-center py-12">
    <mat-icon class="text-gray-400 w-16 h-16 mb-4">schedule</mat-icon>
    <p class="text-gray-500 text-lg mb-2">Keine Kontrolltermine gefunden</p>
    <p class="text-gray-400">Erstellen Sie einen neuen Kontrolltermin oder passen Sie Ihre Filter an.</p>
  </div>

  <!-- Pagination -->
  <mat-paginator
    *ngIf="totalPages > 1"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="currentPage - 1"
    [pageSizeOptions]="[5, 10, 25, 50]"
    showFirstLastButtons
    (page)="onPageChange($event.pageIndex + 1)"
    aria-label="Select page of control appointments">
  </mat-paginator>
</div>



